const blockSelect = document.querySelectorAll('.smooth-block');

blockSelect.forEach(el => {
    const blockSelectHeader = el.querySelector('.smooth-btn');
    const blockSelectList = el.querySelector('.smooth-content');

    blockSelectHeader.addEventListener('click', (e) => {
        e.stopPropagation();

        const isOpen = el.dataset.open === 'true';

        blockSelect.forEach(item => {
            item.dataset.open = 'false';
            item.querySelector('.smooth-btn').classList.remove('active');

            const content = item.querySelector('.smooth-content');
            content.classList.remove('open');
            content.style.maxHeight = '';
        });

        if (!isOpen) {
            el.dataset.open = 'true';
            blockSelectHeader.classList.add('active');
            blockSelectList.classList.add('open');
            blockSelectList.style.maxHeight = `${blockSelectList.scrollHeight}px`;
        }
    });

    if (blockSelectHeader.classList.contains('active')) {
        blockSelectList.style.maxHeight = `${blockSelectList.scrollHeight}px`;
    }
});

document.addEventListener('click', (e) => {
    blockSelect.forEach(item => {
        if (!item.contains(e.target)) {
            item.dataset.open = 'false';
            item.querySelector('.smooth-btn').classList.remove('active');

            const content = item.querySelector('.smooth-content');
            content.classList.remove('open');
            content.style.maxHeight = '';
        }
    });
});